import { ISelectRenderButtonProps } from '@private/components';

import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';

import { StyledButton } from './styled';

const OpenButton = ({
  isOpen,
  loading,
  readonly: _,
  ...props
}: ISelectRenderButtonProps) => {
  return (
    <StyledButton
      {...props}
      $isOpen={isOpen}
      iconSize={24}
      startIcon={loading ? undefined : <ICONS_MAP.ArrowDown />}
      variant='icon'
    />
  );
};

export default appReactMemo(OpenButton);
